import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { EuiModal, EuiOverlayMask, EuiIcon, EuiButton, EuiFlexItem, EuiButtonEmpty, EuiFlexGroup } from '@elastic/eui';
import { marked } from "marked";
import { TranslateLanguage } from './KeywordTranslator';
import './ChatBot.css';
import micIcon from '../assets/CTB-Mic-P.png';
import ReactPlayer from 'react-player';
import parse from "html-react-parser";
import PlaylistModal from "../components/PlaylistModal";
import { createSpeechBridge } from './speechBridge';
import { Converter } from 'opencc-js';
import PressHoldSpeechInput from '../components/PressHoldSpeechInput';
import './press-hold.css';
import { LoginRequiredModal } from './LoginRequiredModal';
import { Capacitor } from '@capacitor/core';

function ChatBotModal({ isVisible, closeModal }) {
  const [message, setMessage] = useState("");
  const [chats, setChats] = useState([{ role: TranslateLanguage(localStorage.userLanguage, "AI詩歌助手"), content: TranslateLanguage(localStorage.userLanguage, "您好，歡迎使用AI詩歌助手！") }]);
  const [reply, setReply] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [threadId, setThreadId] = useState(null);
  const chatWindowRef = useRef(null);
  const user = JSON.parse(sessionStorage.getItem('user'));
  const [username, setUsername] = useState(sessionStorage.getItem('user') ? user.username : "使用者");
  const inputRef = useRef(null);
  const recognitionRef = useRef(null);
  const [isVoiceModalVisible, setIsVoiceModalVisible] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [isVideoModalVisible, setIsVideoModalVisible] = useState(false);
  const [youtubeVideoId, setYoutubeVideoId] = useState(null);
  const [isRecvComplete, setIsRecvComplete] = useState(false);
  const [modalProps, setModalProps] = useState({
    userId: '',
    songId: '',
    videoURL: '',
    type: '',
    engineId: '',
    title: '',
    label: '',
    playlisttype: ''
  });
  const [showPlaylistModal, setShowModal] = useState(false);
  const [currentSongName, setCurrentSongName] = useState("");
  
  const finalTextRef = useRef('');   // 已确认文本
  const draftRef = useRef('');       // 临时（partial）文本

  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    document.title = "Check The Bible";
  }, []);

  useEffect(() => {
    const preventLinkNavigation = (e) => {
      if (e.target.tagName === "A") {
        e.preventDefault();
      }
    };
    document.addEventListener("click", preventLinkNavigation);
    return () => document.removeEventListener("click", preventLinkNavigation);
  }, []);

  const sendMessage = async (text = message) => {
    if (!text.trim()) return;
    setIsRecvComplete(false);
    setChats([...chats, { role: "user", content: text }]);
    setMessage("");
    setIsTyping(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_GptAPI_URL}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: text, threadId }),
      });

      if (!response.ok) throw new Error("Network response was not ok");

      const receivedThreadId = response.headers.get("x-thread-id");
      if (receivedThreadId && !threadId) setThreadId(receivedThreadId);

      const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
      let fullResponse = "";
      let firstChunkReceived = false;

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        fullResponse += value;
        if (!firstChunkReceived) {
          setIsTyping(false);
          firstChunkReceived = true;
        }
        TranslateLanguage(localStorage.userLanguage, fullResponse);
        setReply(marked.parse(fullResponse.replace(/\n/g, "<br />")));
      }

      setChats((prev) => [...prev, {
        role: TranslateLanguage(localStorage.userLanguage, "AI詩歌助手"),
        content: TranslateLanguage(localStorage.userLanguage, marked.parse(fullResponse))
      }]);
      setIsRecvComplete(true);
    } catch (error) {
      console.error("Failed to fetch:", error);
      setIsTyping(false);
    }

    setReply("");
  };

  useEffect(() => {
    if (chatWindowRef.current) {
      chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight;
    }
  }, [chats, reply]);

//   useEffect(() => {
//     // 检查浏览器是否支持 SpeechRecognition API
//     if (!('SpeechRecognition' in window || 'webkitSpeechRecognition' in window)) {
//         console.warn("您的浏览器不支持语音识别功能");
//         return;
//     }

//     // 初始化 SpeechRecognition 实例
//     recognitionRef.current = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
//     recognitionRef.current.lang = 'zh-CN'; // 设置识别语言

//     // 处理识别结果
//     recognitionRef.current.onresult = (event) => {
//         // const transcript = event.results[0][0].transcript;
//         // inputRef.current.value = transcript;
//         // setMessage(transcript);
//         const result = event.results[0][0].transcript;
//         setTranscript(result); // 实时更新识别内容
//     };

//     // 错误处理
//     recognitionRef.current.onerror = (event) => {
//         console.error('语音识别出错:', event.error);
//     };
// }, []);

// const handleVoiceInput = () => {
//   setIsVoiceModalVisible(true); // 打开语音识别提示框
//   setTranscript(""); // 清空之前的识别内容
//   recognitionRef.current.start();
// };

// const handleVoiceSubmit = () => {
//   if (transcript.trim()) { // 确保有内容才发送
//     setMessage(transcript); // 设置搜索框的内容
//     sendMessage(transcript); // 发送消息
//   }
//   setIsVoiceModalVisible(false); // 关闭语音识别提示框
//   recognitionRef.current.stop(); // 停止语音识别
// };

//add on 9/6/2025
// // 让 ref 跟随弹窗状态
// useEffect(() => { isModalOpenRef.current = isVoiceModalVisible; }, [isVoiceModalVisible]);

// // ---- 初始化：配置更稳的识别器 ----
// useEffect(() => {
//   const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
//   if (!SR) {
//     console.warn('此浏览器不支持 Web Speech 语音识别');
//     return;
//   }

//   const rec = new SR();
//   recognitionRef.current = rec;

//   rec.lang = 'zh-CN';         // 或 'zh-TW' / 'zh-HK'
//   rec.interimResults = true;  // 临时结果（边说边出）
//   rec.continuous = true;      // 尽量持续识别（Safari 支持有限）
//   rec.maxAlternatives = 1;

//   rec.onstart = () => setIsListening(true);

//   rec.onresult = (e) => {
//     let interimChunk = '';
//     let finalChunk = '';
//     for (let i = e.resultIndex; i < e.results.length; i++) {
//       const r = e.results[i];
//       const txt = r[0].transcript;
//       if (r.isFinal) finalChunk += txt;
//       else interimChunk += txt;
//     }
//     if (finalChunk) {
//       finalTextRef.current += finalChunk;
//       setTranscript(finalTextRef.current);
//     }
//     if (interimChunk) {
//       setTranscript(finalTextRef.current + interimChunk);
//     }
//   };

//   // iOS/Safari 会频繁 end；在弹窗没关时自动续认
//   rec.onend = () => {
//     setIsListening(false);
//     if (isModalOpenRef.current) {
//       setTimeout(() => {
//         try { rec.start(); } catch {}
//       }, 120);
//     }
//   };

//   rec.onerror = (e) => {
//     console.error('语音识别错误:', e.error);
//     // 常见: 'not-allowed'（权限被拒）/ 'no-speech'（无语音）/ 'network'
//   };

//   // 卸载清理
//   return () => {
//     try { rec.onresult = rec.onend = rec.onerror = rec.onstart = null; rec.stop(); rec.abort(); } catch {}
//     recognitionRef.current = null;
//   };
// }, []);

// const handleVoiceInput = () => {
//   const rec = recognitionRef.current;
//   if (!rec) return;

//   // 重置显示
//   finalTextRef.current = '';
//   setTranscript('');
//   setIsVoiceModalVisible(true);

//   // 避免重复 start 抛 InvalidStateError
//   try {
//     if (isListening) rec.stop();
//     rec.start();                    // 必须在“用户手势”回调里调用
//   } catch (err) {
//     if (err.name === 'InvalidStateError') {
//       try { rec.stop(); } catch {}
//       setTimeout(() => { try { rec.start(); } catch {} }, 150);
//     } else {
//       console.warn('start 失败：', err);
//     }
//   }
// };

// const handleVoiceSubmit = () => {
//   const text = transcript.trim();
//   if (text) {
//     setMessage(text);
//     sendMessage(text);
//   }
//   setIsVoiceModalVisible(false);
//   const rec = recognitionRef.current;
//   if (rec) { try { rec.onend = null; rec.stop(); rec.abort(); } catch {} }
//   setIsListening(false);
// };

//add capacitor
  // ==== 1) 站内语言 S/T（SSR 安全） ====
  const uiST = useMemo(() => {
    try {
      return (typeof window !== 'undefined' &&
        window.localStorage?.getItem('userLanguage') === 'T') ? 'T' : 'S';
    } catch { return 'S'; }
  }, []);
  // 2) 计算语音识别用的 BCP-47 语言码
  const speechLang = useMemo(() => (uiST === 'T' ? 'zh-TW' : 'zh-CN'), [uiST]);

  // 3) —— 准备转换器：简→繁 / 繁→简（只在需要时启用）
  const toTW = useMemo(() => Converter({ from: 'cn', to: 'tw' }), []);
  const toCN = useMemo(() => Converter({ from: 'tw', to: 'cn' }), []);
  const normalize = useCallback(
    (txt) => (uiST === 'T' ? toTW(txt) : toCN(txt)), [uiST, toTW, toCN]
  );
// ==== 4) 创建 bridge（语言或 normalize 变化会重建） ====
const speech = useMemo(() => createSpeechBridge({
  lang: speechLang,
  preferAzureOnAndroidChrome: true,      // ← 开启 Android Chrome 优先 Azure
  azure: {
    region: 'westus',                  // 和后端发 token 的 Region 一致
    tokenUrl: '/api/speech/token',       // 你后端的短期 token 接口
  },
  onPartial: (t) => {
    draftRef.current = normalize(t);
    // 预览 = 已确认 + 临时（不覆盖已确认）
    setTranscript(finalTextRef.current + draftRef.current);
  },
  onFinal: (t) => {
    // 优先落最后一次 partial，避免重复追加
    const commit = draftRef.current || normalize(t) || '';
    if (commit && !finalTextRef.current.endsWith(commit)) {
      finalTextRef.current += commit;
    }
    draftRef.current = '';
    setTranscript(finalTextRef.current);
  },
}), [speechLang, normalize]);

// ==== 6) 打开/提交/取消 ====
// 打开（开始聆听）
  const handleVoiceInput = useCallback(async () => {
    // 清空上一轮
    finalTextRef.current = '';
    draftRef.current = '';
    setTranscript('');

    setIsVoiceModalVisible(true);
    try {
      await speech.start();        // 必须放在用户点击事件中调用
    } catch (e) {
      console.error(e);
      setIsVoiceModalVisible(false);
      // TODO: 这里可弹 toast：请允许麦克风或设备不支持语音
    }
  }, [speech]);

  // 提交（结束并发送）
  const handleVoiceSubmit = useCallback(async () => {
    const text = (finalTextRef.current || transcript).trim();
    if (text) {
      setMessage(text);            // 你的逻辑
      sendMessage(text);           // 你的逻辑
    }
    setIsVoiceModalVisible(false);
    try { await speech.stop(); } catch {}
  }, [transcript, speech]);

  // 取消（结束但不发送）—— “另外一处调用地方”
  const handleVoiceCancel = useCallback(async () => {
    setIsVoiceModalVisible(false);
    try { await speech.stop(); } catch {}
  }, [speech]);

  // ==== 7) 组件卸载或 bridge 变更时清理 ====
  useEffect(() => {
    return () => { speech.stop(); };
  }, [speech]);

  // ==== 8) 聆听中切换简/繁 → 自动重启一次以生效 ====
  useEffect(() => {
    if (!isVoiceModalVisible) return;
    (async () => {
      try {
        await speech.stop();
        await speech.start();
      } catch (e) {
        console.error(e);
        setIsVoiceModalVisible(false);
      }
    })();
  // 仅在语言变更时触发重启
  }, [speechLang]);
  

  // —— YouTube 解析/点击 —— //
  const extractYouTubeId = (url) => {
    const regex = /(?:youtube\.com\/(?:.*v=|.*\/embed\/|.*\/v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const handleYouTubeLinkClick = async (videoId) => {
    if (!videoId) return;
    setYoutubeVideoId(videoId);
    setIsVideoModalVisible(true);

    try {
      const response = await fetch(`/api/VideoCheck/get-name?videoId=${videoId}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      if (!response.ok) throw new Error(`Error: ${response.statusText}`);
      const result = await response.json();
      setCurrentSongName(result?.title || "贊美詩歌");
    } catch {
      setCurrentSongName("贊美詩歌");
    }
  };

  const renderReplyWithYouTube = (reply) => {
    return parse(reply, {
      replace: (domNode) => {
        if (domNode.name === "a" && domNode.attribs?.href) {
          const videoId = extractYouTubeId(domNode.attribs.href);
          const songName = domNode.children?.[0]?.data || "未知歌曲";
          if (videoId) {
            return (
              <span
                key={videoId}
                onClick={() => handleYouTubeLinkClick(videoId, songName)}
                style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
              >
                {songName}
              </span>
            );
          }
        }
      },
    });
  };

  return (
    <>
      {isVisible && (
        <EuiOverlayMask>
          <EuiModal
            onClose={closeModal}
            className="chatbot-modal"
            style={{
              width: 'min(900px, calc(100vw - 24px))',
              maxWidth: 'min(900px, calc(100vw - 24px))',
              height: 'auto',
              // maxHeight: 'calc(100vh - 24px)',
              maxHeight: 'calc(var(--app-viewport-height) - 24px)',
              overflow: 'hidden',
            }}
          >
            <header className="chat-header">
              <div className="chat-title">{TranslateLanguage(localStorage.userLanguage, "AI詩歌助手")}</div>
            </header>

            <div className="chat-window" ref={chatWindowRef}>
              {chats.map((chat, index) => (
                <div key={index} className={chat.role === "user" ? "user-msg" : "assistant-msg"}>
                  <b>{chat.role === "user" ? TranslateLanguage(localStorage.userLanguage, username) : chat.role.toUpperCase()}:</b>
                  {isRecvComplete ? (
                    renderReplyWithYouTube(chat.content)
                  ) : (
                    <span dangerouslySetInnerHTML={{ __html: chat.content }}></span>
                  )}
                </div>
              ))}
              {isTyping && (
                <div className="typing-indicator">
                  <b>{TranslateLanguage(localStorage.userLanguage, "AI詩歌助手:")}</b> <em>分析中。。。</em>
                </div>
              )}
              {reply && (
                <div className="assistant-msg">
                  <b>{TranslateLanguage(localStorage.userLanguage, "AI詩歌助手:")}</b>
                  <span dangerouslySetInnerHTML={{ __html: reply }}></span>
                </div>
              )}
            </div>

            {/* <form onSubmit={(e) => { e.preventDefault(); sendMessage(); }} className="chat-input">
              <div className="input-wrapper">
                <input
                  type="text"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder={TranslateLanguage(localStorage.userLanguage, "請向我提問，例如推薦與信心相關的詩歌")}
                  ref={inputRef}
                  className="input-field"
                />
                {!Capacitor.isNativePlatform() && (
                  <EuiIcon
                    type={micIcon}
                    onClick={handleVoiceInput}
                    className="voice-icon"
                    aria-label="Start voice input"
                  />
                )}
              </div>
              <button type="submit">{TranslateLanguage(localStorage.userLanguage, "發送")}</button>
            </form>

            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <EuiButton size="s" color="danger" iconType="arrowLeft" onClick={closeModal} style={{ width: 120 }}>
                {TranslateLanguage(localStorage.userLanguage, "關閉")}
              </EuiButton>
            </div> */}
            <form
              id="chat-form"
              onSubmit={(e) => { e.preventDefault(); sendMessage(); }}
              className="chat-input"
            >
              <div className="input-wrapper">
                <input
                  type="text"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder={TranslateLanguage(localStorage.userLanguage, "請向我提問，例如推薦與信心相關的詩歌")}
                  ref={inputRef}
                  className="input-field"
                />
                {!Capacitor.isNativePlatform() && (
                  <EuiIcon
                    type={micIcon}
                    onClick={handleVoiceInput}
                    className="voice-icon"
                    aria-label="Start voice input"
                  />
                )}
              </div>
              {/* <PressHoldSpeechInput value={message} placeholder={TranslateLanguage(localStorage.userLanguage, "請向我提問，例如推薦與信心相關的詩歌")} onChange={setMessage} /> */}
              {/* 這裡移除原本的發送按鈕 */}
            </form>

            {/* 底部操作區：左右均勻分佈 */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 12,
                marginTop: 10,
                padding: '0 12px',       // ⬅️ 左右留白
                width: '100%',
                boxSizing: 'border-box', // 确保 padding 不挤压布局
              }}
            >
              <EuiButton
                size="s"
                color="danger"
                iconType="arrowLeft"
                onClick={closeModal}
                style={{ width: 120 }}
              >
                {TranslateLanguage(localStorage.userLanguage, "關閉")}
              </EuiButton>

              <EuiButton
                fill
                size="s"
                iconType="check"
                type="submit"
                form="chat-form"   // 讓按鈕在表單外也能提交
                style={{ width: 120 }}
              >
                {TranslateLanguage(localStorage.userLanguage, "發送")}
              </EuiButton>
            </div>
          </EuiModal>
        </EuiOverlayMask>
      )}

      {/* 语音识别提示框 */}
      {isVoiceModalVisible && (
        <EuiOverlayMask>
          <EuiModal onClose={handleVoiceCancel} style={{ width: '400px' }}>
            <h2 style={{ textAlign: "center" }}>{TranslateLanguage(localStorage.userLanguage, "語音識別中")}</h2>
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <p>{transcript || TranslateLanguage(localStorage.userLanguage, "正在聆聽...")}</p>
            </div>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
              <EuiButton onClick={handleVoiceSubmit} fill>
                {TranslateLanguage(localStorage.userLanguage, "提交")}
              </EuiButton>
              <EuiButton onClick={handleVoiceCancel} color="danger" style={{ marginLeft: "10px" }}>
                {TranslateLanguage(localStorage.userLanguage, "取消")}
              </EuiButton>
            </div>
          </EuiModal>
        </EuiOverlayMask>
      )}

      {/* 视频播放模态框 */}
      {isVideoModalVisible && (
        <EuiOverlayMask>
          <EuiModal
            onClose={() => setIsVideoModalVisible(false)}
            style={{
              width: '80vw',
              maxWidth: '720px',
              height: 'auto',
              maxHeight: '80vh',
              overflow: 'auto',
            }}
          >
            <div style={{ position: 'relative', paddingTop: '56.25%' }}>
              <ReactPlayer
                url={`https://www.youtube.com/watch?v=${youtubeVideoId}`}
                controls
                width="100%"
                height="100%"
                style={{ position: 'absolute', top: 0, left: 0 }}
              />
            </div>

            <div style={{ marginTop: '10px' }}>
              <EuiFlexGroup justifyContent="center" gutterSize="s">
                <EuiFlexItem grow={false}>
                  <EuiButtonEmpty
                    iconType="heart"
                    size="s"
                    color="primary"
                    onClick={() => {
                      const user = sessionStorage.getItem('user');
                      if (user) {
                        setModalProps({
                          userId: JSON.parse(user).id,
                          songId: youtubeVideoId,
                          videoURL: `https://www.youtube.com/watch?v=${youtubeVideoId}`,
                          type: '詩歌',
                          engineId: `AI-songs|${youtubeVideoId}`,
                          label: 'v',
                          playlisttype: 'song',
                          title: currentSongName,
                        });
                        setShowModal(true);
                      } else {
                        // TODO: 未登录时的处理（你原先的 SavePlayListItem 这里变量未定义，保留逻辑即可）
                        // SavePlayListItem("", 1, YTVideo.id, YTVideo.videoURL, YTVideo.title);
                        setShowLoginModal(true);
                      }
                    }}
                  >
                    {TranslateLanguage(localStorage.userLanguage, "加入我的歌單")}
                  </EuiButtonEmpty>
                </EuiFlexItem>

                <EuiFlexItem grow={false}>
                  <EuiButtonEmpty
                    iconType="cross"
                    size="s"
                    color="danger"
                    onClick={() => setIsVideoModalVisible(false)}
                  >
                    {TranslateLanguage(localStorage.userLanguage, "關閉")}
                  </EuiButtonEmpty>
                </EuiFlexItem>
              </EuiFlexGroup>
            </div>
          </EuiModal>
        </EuiOverlayMask>
      )}

      {/* 渲染 PlaylistModal */}
      {showPlaylistModal && (
        <PlaylistModal
          userId={modalProps.userId}
          songId={modalProps.songId}
          videoURL={modalProps.videoURL}
          title={modalProps.title}
          type={modalProps.type}
          engineId={modalProps.engineId}
          label={modalProps.label}
          playlisttype={modalProps.playlisttype}
          closeModal={() => setShowModal(false)}
        />
      )}
      <LoginRequiredModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        nextUrl={typeof window !== 'undefined' ? window.location.href : '/'}
        title={TranslateLanguage(localStorage.userLanguage, "請先登入")}
        message={TranslateLanguage(localStorage.userLanguage, "登入後即可使用此功能，若還不是用戶請注冊用戶。")}
      />
    </>
  );
}

export default ChatBotModal;
